export const CoreWebVital = {
    CUMULATIVE_LAYOUT_SHIFT: 'cls',
    FIRST_CONTENTFUL_PAINT: 'fcp',
    FIRST_INPUT_DELAY: 'fid',
    INTERACTION_TO_NEXT_PAINT: 'inp',
    LARGEST_CONTENTFUL_PAINT: 'lcp',
    TIME_TO_FIRST_BYTE: 'ttfb',
};
export const CoreWebVitalsThresholds = {
    // https://web.dev/articles/cls
    // good 0.1 improve 0.25 poor
    [CoreWebVital.CUMULATIVE_LAYOUT_SHIFT]: {
        good: 0.1,
        poor: 0.25,
    },
    // https://web.dev/articles/fcp
    // good 1.8s improve 3.0s poor
    [CoreWebVital.FIRST_CONTENTFUL_PAINT]: {
        good: 1800,
        poor: 3000,
    },
    // https://web.dev/articles/fid
    // good 100ms improve 300ms poor
    [CoreWebVital.FIRST_INPUT_DELAY]: {
        good: 100,
        poor: 300,
    },
    // https://web.dev/articles/inp
    // good 200ms improve 500ms poor
    [CoreWebVital.INTERACTION_TO_NEXT_PAINT]: {
        good: 200,
        poor: 500,
    },
    // https://web.dev/articles/lcp
    // good 2.5s improve 4.0s poor
    [CoreWebVital.LARGEST_CONTENTFUL_PAINT]: {
        good: 2500,
        poor: 4000,
    },
    // https://web.dev/articles/ttfb
    // good 800ms improve 1800ms poor
    [CoreWebVital.TIME_TO_FIRST_BYTE]: {
        good: 800,
        poor: 1800,
    },
};
//# sourceMappingURL=coreWebVitals.js.map